import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

/* import from view folder */
import buttonTabs from "../../assecs/json/tabs/language.json";

/* import element from component folder */
import Editor from "../../components/quill";

const TabEditor = ({ source, currentTab = 'descriptionEnglish', changeHandle, readOnly }) => {
    const [current, setCurrent] = useState(currentTab);
    const [value, setValue] = useState('');

    const editorHandler = htmlString => {
        const resource = {
            target: { name: current, value: htmlString }
        };

        setValue(htmlString);
        changeHandle(resource);
    };

    useEffect(() => { 
        setValue(source[current]) }, [ current ]
    );

    return (
        <div className='language-editor'>
            <div className="language-tab">
            {
                buttonTabs.map(({ type, text }) => 
                    <Button key={ type } data-current={ current === type } onClick={ () => setCurrent(type) }>{ text }</Button>
                )
            }
            </div>
            <Editor source={ value } changeHandle={ editorHandler } readOnly = { readOnly } />
        </div>
    );
};
export default React.memo(TabEditor);